import { useEffect } from "react";
import moment from "moment";
import PropTypes from 'prop-types';

// @mui material components
import Grid from "@mui/material/Grid";
import { Box, Card, Tooltip } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
// Data
import { Link, useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import ClearwayCalendar from "components/Calendars/ClearwayCalendar";

import { useAuth0 } from "@auth0/auth0-react";
import SoftButton from "components/SoftComponents/SoftButton";
import { getUserAccessLevel } from "utils/setup";
import clearwaysAPI from "modules/clearways/api";
import { useSoftUIController } from "hooks/context";
import { disableMap } from "utils/map";
import { wrapper, loadingScreen } from "utils/wrapper";

function ClearwaysEventsView({ map, user }) {
    disableMap(map);

    clearwaysAPI.loadToken(useAuth0());
    const [controller] = useSoftUIController();
    const { deviceLayout } = controller;

    const navigate = useNavigate();

    const onEventClick = function (info) {
        let path = '/clearways/events/' + info.event.extendedProps.event_id;
        navigate(path);
    }

    const date = moment();
    const month = date.month();
    const year = date.year();

    const clearways = useQuery({
        queryKey: ['getClearwaysWithYearAndMonth', year, month],
        queryFn: async () => {
            return clearwaysAPI.getClearwaysWithYearAndMonth(year, month)
        },
    });

    if (clearways.isLoading) {
        return loadingScreen(deviceLayout, false);
    }
    else if (clearways.error) {
        return wrapper('Error!');
    }
    else if (!clearways.data) {
        return loadingScreen(deviceLayout, false);
    }

    return (
        wrapper((
            <SoftBox sx={{ overflow: "visible", backgroundColor: 'transparent' }}>
                <Box p={1}>
                    <Card sx={{ minHeight: deviceLayout == 'mobile' ? 'calc(100svh - 5.75rem - 8px)' : 'calc(100svh - 6.5rem - 16px)', height: '100%' }}>
                        <SoftBox px={2} pt={2} height="100%" display='flex' flexDirection='row' justifyContent='space-between' alignItems="flex-end">
                            <SoftBox height="100%" display='flex'>
                                <SoftTypography variant={deviceLayout == 'mobile' ? "h4" : "h4"}>Clearways Calendar</SoftTypography>
                                {/* <Tooltip title={<div style={{ textAlign: 'left' }}>Faded - Past Events<br />Grey - Warning Period<br />Green - Active Period</div>} placement="right" sx={{ paddingLeft: '5px', paddingBottom: '6px' }}>
                                    <HelpOutlineIcon fontSize="small" />
                                </Tooltip> */}
                            </SoftBox>
                            {getUserAccessLevel(user.user.user_type, 'editor') && (
                                <SoftBox display='flex' flexDirection='row' justifyContent={{ xxs: 'center', md: 'flex-end' }}>
                                    <Link to={'/clearways/event'} style={{ textDecoration: 'none' }}>
                                        <SoftButton variant='gradient' color='dark' size={deviceLayout == 'mobile' ? "small" : "medium"}>{deviceLayout == 'mobile' ? "Add" : "Add Event"}</SoftButton>
                                    </Link>
                                </SoftBox>
                            )}
                        </SoftBox>
                        <SoftBox mb={2} sx={({ typography: { fontFamily } }) => ({ fontFamily: fontFamily })}>
                            <ClearwayCalendar date={date.format("YYYY-MM-DD")} data={clearways.data} onEventClick={onEventClick} />
                        </SoftBox>
                    </Card>
                </Box>
            </SoftBox >
        ), deviceLayout, true)
    );
}

ClearwaysEventsView.propTypes = {
    map: PropTypes.object,
    user: PropTypes.object
}

export default ClearwaysEventsView;